import React, { useEffect, useRef, useState } from "react";
import ProfileImg from "../assets/images/profile-img.png";

import linkedin from "../assets/images/ln.png";
import gmail from "../assets/images/gmail.png";
import call from "../assets/images/call.png";

import HomeSvg from "../assets/images/svg/home-svg.svg";
import AboutSvg from "../assets/images/svg/about-svg.svg";
import ResumeSvg from "../assets/images/svg/resume-svg.svg";
import ServicesSvg from "../assets/images/svg/services-svg.svg";
import PortfolioSvg from "../assets/images/svg/portfolio-svg.svg";
import ContactSvg from "../assets/images/svg/contact-svg.svg";
import data from "../assets/images/test-data.gif";

import FlowerImg from "../assets/images/flower.png";
import BrandLogo1 from "../assets/images/brand-logo1.png";
import BrandLogo2 from "../assets/images/brand-logo2.png";
import BrandLogo3 from "../assets/images/brand-logo3.png";
import BrandLogo4 from "../assets/images/brand-logo4.png";
import AboutSection from "./About";
import Resume from "./Resume";
import Portfolio from "./Portfolio";
import Blog from "./Blog";
import Contact from "./Contact";
import $ from "jquery";
import { Link } from "react-router-dom";
const Home = () => {
  //Text
  const firstTexts = ["Data Enthusiast"];
  const secondTexts = ["Digital Analytics & Adobe Target Specialist"];
  const intervalTime = 600;

  const [firstTextIndex, setFirstTextIndex] = useState(0);
  const [secondTextIndex, setSecondTextIndex] = useState(0);

  useEffect(() => {
    const firstTextTimeout = setTimeout(() => {
      setFirstTextIndex((prevIndex) => (prevIndex + 1) % firstTexts.length);
    }, intervalTime * 3);

    return () => clearTimeout(firstTextTimeout);
  }, [firstTextIndex]);

  useEffect(() => {
    const secondTextTimeout = setTimeout(() => {
      setSecondTextIndex((prevIndex) => (prevIndex + 1) % secondTexts.length);
    }, intervalTime * 3);

    return () => clearTimeout(secondTextTimeout);
  }, [secondTextIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFirstTextIndex((prevIndex) => (prevIndex + 1) % firstTexts.length);
      setSecondTextIndex((prevIndex) => (prevIndex + 1) % secondTexts.length);
    }, intervalTime * 7);

    return () => clearInterval(interval);
  }, []);


  // Toggle Btn
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const menuToggle = document.getElementById("menu-toggle");
    const sideMenu = document.querySelector(".side-menu");
    const menuItems = document.querySelectorAll(".menu-list-main li");

    const handleMenuToggle = () => {
      setMenuOpen(!menuOpen);
      menuToggle.classList.toggle("open");
      sideMenu.classList.toggle("show");
    };

    const handleMenuItemClick = (event) => {
      event.preventDefault();
      const linkElement = event.currentTarget.querySelector("a");
      if (linkElement) {
        const targetId = linkElement.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
        setMenuOpen(false);
        menuToggle.classList.remove("open");
        sideMenu.classList.remove("show");
      }
    };

    if (menuToggle && sideMenu && menuItems.length > 0) {
      menuToggle.addEventListener("click", handleMenuToggle);
      menuItems.forEach((item) => {
        item.addEventListener("click", handleMenuItemClick);
      });

      $(".hamburger").click(function () {
        $(this).toggleClass("is-active");
      });

      return () => {
        menuToggle.removeEventListener("click", handleMenuToggle);
        menuItems.forEach((item) => {
          item.removeEventListener("click", handleMenuItemClick);
        });
      };
    }
  }, [menuOpen]);

  const [activeLink, setActiveLink] = useState("");

  const handleClick = (event, id) => {
    event.preventDefault();
    setActiveLink(id);
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <button id="menu-toggle" className="menu-toggle-button">
        <span className="hamburger" id="hamburger-1">
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </span>
      </button>
      <div className="side-menu">
        <div className="profile-img-main">
          <img src={ProfileImg} alt="profile-img" />
          <h1>
            Tushar <span>Kohli</span>
          </h1>
          <h2 className="designer">{firstTexts[firstTextIndex]}</h2>

          <div className="profile-media-icons-main fade_up">
            <a href="mailto:tusharkohli07@gmail.com" className="profile-media-icons">
              <img src={gmail} alt="email-svg" />
            </a>
            <Link to="https://www.linkedin.com/in/tushar-kohli-713a07164?href=resume" target="_blank" className="profile-media-icons">
              <img src={linkedin} alt="linkedin" />
            </Link>
            <a href="tel:+14379821347" className="profile-media-icons">
              <img src={call} alt="medium-svg" />
            </a>
          </div>
        </div>
        <div className="menu-list-main">
          <ul>
            <li
              className={`active-menu-action ${activeLink === "home" ? "active" : ""
                }`}
            >
              <a

                href="#home"
                onClick={(e) => handleClick(e, "home")}
              >
                <img src={HomeSvg} alt="home-svg" />
                Home
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "about" ? "active" : ""
                }`}
            >
              <a

                href="#about"
                onClick={(e) => handleClick(e, "about")}
              >
                <img src={AboutSvg} alt="home-svg" />
                About
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "resume" ? "active" : ""
                }`}
            >
              <a

                href="#work"
                onClick={(e) => handleClick(e, "work")}
              >
                <img src={ResumeSvg} alt="home-svg" />
                Work Experience
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "services" ? "active" : ""
                }`}
            >
              <a

                href="#analyticsSkills"
                onClick={(e) => handleClick(e, "analyticsSkills")}
              >
                <img src={ServicesSvg} alt="home-svg" />
                Analytics
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "services" ? "active" : ""
                }`}
            >
              <a

                href="#frontend"
                onClick={(e) => handleClick(e, "frontend")}
              >
                <img src={ServicesSvg} alt="home-svg" />
                Front End
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "services" ? "active" : ""
                }`}
            >
              <a

                href="#database"
                onClick={(e) => handleClick(e, "database")}
              >
                <img src={ServicesSvg} alt="home-svg" />
                Backend & Database
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "portfolio" ? "active" : ""
                }`}
            >
              <a

                href="#certification"
                onClick={(e) => handleClick(e, "certification")}
              >
                <img src={PortfolioSvg} alt="home-svg" />
                Certifications
              </a>
            </li>
            <li
              className={`active-menu-action ${activeLink === "contact" ? "active" : ""
                }`}
              id="contact-line"
            >
              <a

                href="#contact"
                onClick={(e) => handleClick(e, "contact")}
              >
                <img src={ContactSvg} alt="home-svg" />
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div id="wrap">
            <Link
              to={"https://drive.google.com/file/d/1jnR2UHH-fD8u-nz8j-r61wE0sM-xz14p/view?usp=drive_link"}
              rel="noreferrer"
              target="_blank"
              className="btn-slide"
            >
              <span className="circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    className="download-svg"
                    d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span className="title">Download CV</span>
              <span className="title-hover">Click Here</span>
            </Link>
          </div>
        </div>
      </div>

      {/* <!-- ====================================== Side Menu End ===================================== --> */}
      <div className="main-containe" data-bs-spy="scroll">
        {/* <!-- ====================================== Section One ===================================== --> */}
        <section className="section-one overflow-hidden" id="home">
          <div className="row">
            <div className="col-xxl-6 col-lg-6">
              <h2 className="jessica-main-text">
                Tushar <span>Kohli</span>
              </h2>
              <h3 className="back-End-dev designer2">
                {secondTexts[secondTextIndex]}
              </h3>
              <p className="best" style={{ color: '#cbcbcb', fontSize: '16px' }}>
              With over 7 years of experience, I specialize in implementing and optimizing digital analytics and personalization solutions using tools like Adobe Analytics, Adobe Launch, Adobe Target, Web SDK, Quantum Metric, OneTrust, and the Google Analytics stack. I focus on designing and executing experimentation and personalization strategies that improve user engagement and conversion. By collaborating closely with stakeholders, I define KPIs, analyze user behavior, and drive data-informed decisions that enhance user experiences and align with business objectives.              </p>
              <div className="section-one-btns-main">
                <div className="wrapper">
                  <Link className="btn-hover btn-hover2" to="#contact" onClick={(e) => handleClick(e, "contact")}>
                    Contact Me
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-lg-6 position-relative">
              <img className="flower" src={FlowerImg} alt="flower" />
              <img
                className="tushar-main-img"
                src={data}
                alt="tushar-main-img"
              />

              <div className="worked-box">
                <p className="worked-more">Driven by data. Powered by <span className="passion">passion. </span></p>

              </div>
            </div>
          </div>
        </section>
        {/* <!-- ====================================== Section Marquee ===================================== --> */}
        <section className="Marquee-main overflow-hidden">
          <h3 className="fade_up">Companies I've Worked With</h3>
          <div className="logos logos2">
            <div>
              <div className="marquee__content">
                <div className="marquee-img-main col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5" style={{ background: '#ffffff' }}>
                  <img
                    className="brand-logos"
                    src={BrandLogo2}
                    alt="brand-logo2"
                  />
                </div>
                <div className="marquee-img-main col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5" style={{ background: '#ffffff' }}>
                  <img
                    className="brand-logos"
                    src={BrandLogo3}
                    alt="brand-logo3"
                  />
                </div>
                <div className="marquee-img-main col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5" style={{ background: '#ff3131' }}>
                  <img
                    className="brand-logos"
                    src={BrandLogo1}
                    alt="brand-logo1"
                  />
                </div>
                <div className="marquee-img-main col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-5" style={{ background: '#ffffff' }}>
                  <img
                    className="brand-logos"
                    src={BrandLogo4}
                    alt="brand-logo4"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <AboutSection />
        <Resume />
        <Portfolio />
        {/* <Blog /> */}
        <Contact />
      </div>
    </>
  );
};
export default Home;
